import { instBundle } from '@/axios.js';
import util from '@/util.js';
import { beautyProfileTypeList } from '@/constants.js';
import { beautyProfileTitleFromIdList } from '@/util.js';

const axiosAdmin2 = instBundle.axiosAdmin2;

const _yOrN = value => (value ? 'Y' : 'N');

const state = {
	beforeParams: null,
	orderDefault: null,
	pageType: '', // RegisterList: '검색',
	keyList: [],
	order: null,
	limit: null,
	offset: 0,
	orderList: [],
	list: [],
	contentTotal: 0,
	snsList: [
		{ id: null, value: '선택' },
		{ id: 'kakao', value: 'KAKAO' },
		{ id: 'facebook', value: 'FACEBOOK' },
		{ id: 'APPLE', value: 'APPLE' },
		{ id: 'GOOGLE', value: 'GOOGLE' },
		{ id: 'NAVER', value: 'NAVER' },
		{ id: 'none', value: '없음' },
	],
	isBlindList: [
		{ id: null, value: '전체' },
		{ id: 1, value: '수동' },
		{ id: 2, value: '자동' },
		{ id: 0, value: '정상' },
	],
	osList: [
		{ id: 'truetrue', value: '안드로이드 / IOS' },
		{ id: 'truefalse', value: '안드로이드' },
		{ id: 'falsetrue', value: 'IOS' },
		{ id: 'falsefalse', value: '' },
	],
};

const getters = {
	getValue: state => (key, id) => {
		if (!state.hasOwnProperty(`${key}List`)) return null;
		const targetItem = state[`${key}List`].filter(
			item => item.id === id
		)[0];
		return targetItem ? targetItem.value : null;
	},
	// 임시코드
	instaInfo: (state, getters, rootState, rootGetters) => exAd => ({
		instaStatus: exAd?.type === 'instagram' ? '연동' : '미연동',
		instaCate:
			rootGetters['getItemById'](
				'instaCate',
				exAd?.doc?.instagram?.category
			)?.txt || '',
	}),
	// 임시코드
	getDefaultList: (state, getters, rootState, rootGetters) => (item, idx) => {
		return {
			idx: state.offset + (idx + 1),
			idRegister: item.idRegister,
			infoLink: `/register/register-info/${item.idRegister}`,
			nickname: item.nickname,
			grade:
				typeof item.grade === 'number'
					? rootGetters['getItemById']('grade', item.grade).name
					: '',
			email: item.email,
			userName: item.userName,
			userTel: item.userTel,
			createDate: item.createDate,
			lastDate: item.lastDate,
			sns: item.sns,
			gender:
				typeof item.gender === 'number'
					? rootGetters['getItemById']('gender', item.gender).name
					: '',
			age: item.age,
			skinType:
				typeof item.skinType === 'number'
					? rootGetters['getItemById']('skinType', item.skinType).name
					: '',
			...getters['instaInfo'](item.externalAdvertising),
			reviewCount: item.reviewCount,
			winCount: item.winCount,
			hasFileName: !!item.fileSaveName,
			fcmToken: item.fcmToken || {},
			beautyProfileList: (item.beautyProfileList || []).map(
				({ id }) => id
			),
			isPickple: item.isPickple,
            isCertification: item.isCertification,
		};
	},
	getActivatedList(state, getters) {
		return state.list.map((item, idx) => {
			return getters['getDefaultList'](item, idx);
		});
	},
	getInactivatedList(state, getters) {
		return state.list.map((item, idx) => {
			const obj = getters['getDefaultList'](item, idx);
			obj.inactivatedDate = item.inactivatedDate;
			return obj;
		});
	},
	getClosedList(state) {
		return state.list.map((item, idx) => {
			return {
				idx: state.offset + (idx + 1),
				idRegister: item.idRegister,
				infoLink: `/register/register-info/${item.idRegister}`,
				nickname: item.nickname,
				createDate: item.createDate,
				closedDate: item.closedDate,
				after6mDate: item.after6mDate,
				reviewCount: item.reviewCount,
			};
		});
	},
	hasAuthority(state, getters, rootState) {
		const NODE_BUILD = rootState.env.NODE_BUILD;
		const { department, adminLevel } = rootState.login;
		return !NODE_BUILD || department === 2038 || adminLevel === 1;
	},
};

const mutations = {
	changeState(state, changes) {
		if (Array.isArray(changes)) {
			changes.forEach(changeItem => {
				if (state.hasOwnProperty([changeItem.key]))
					state[changeItem.key] = changeItem.value;
			});
		} else {
			if (state.hasOwnProperty([changes.key]))
				state[changes.key] = changes.value;
		}
	},
	pageType(state, type) {
		state.pageType = type;
	},
};

const actions = {
	async getList({ state }, params) {
		try {
			params.order = state.order;
			params.limit = state.limit;
			params.offset = state.offset;
			state.beforeParams = params;
			const { data } = await axiosAdmin2.post(
				`/api/registers/${state.pageType}`,
				params
			);
			if (!data.data || !Array.isArray(data.data)) {
				state.contentTotal = 0;
				state.list = [];
				return;
			}
			state.contentTotal = data.contentTotal;
			state.list = data.data;
		} catch (err) {
			console.error(err);
			alert('회원 리스트를 불러오는데 실패했습니다. 개발팀에 문의하세요');
		}
	},
	async downExcel({ state, rootState, getters, rootGetters }, params) {
		try {
			const {
				data: { data },
				config,
			} = await axiosAdmin2.post(
				`/api/registers/${state.pageType}`,
				params
			);
			const rows = data.map(item => {
				item.beautyProfileList = (item.beautyProfileList || []).map(
					({ id }) => id
				);
				const row = [
					item.idRegister,
					item.nickname,
					typeof item.grade === 'number'
						? rootGetters.getItemById('grade', item.grade).name
						: '',
					getters.getValue('isBlind', item.isBlind),
					item.email,
					item.createDate,
					item.sns ? item.sns.split(',').join(' ') : '',
					item.gender
						? rootGetters.getItemById('gender', item.gender).name
						: '',
					item.age,
					item.skinType
						? rootGetters.getItemById('skinType', item.skinType)
								.name
						: '',
					...beautyProfileTypeList.map(beautyProfileTypeItem =>
						beautyProfileTitleFromIdList(
							item.beautyProfileList,
							beautyProfileTypeItem.type
						)
					),
					item.isPickple ? 'Y' : 'N',
                    item.isCertification ? 'Y' : 'N',
					getters.instaInfo(item.externalAdvertising).instaStatus,
					item?.externalAdvertising?.doc?.instagram?.url || '',
					getters.instaInfo(item.externalAdvertising).instaCate,
					_yOrN(item.regId),
					_yOrN(item.apns),
					item.fcmToken && item.fcmToken.id
						? `OS종류 : ${item.fcmToken.os} / OS버전 : ${item.fcmToken.osVersion} / 앱버전 : ${item.fcmToken.appVersion} / 디바이스 모델 : ${item.fcmToken.deviceModel}`
						: '',
					item.reviewCount,
					item.blindedReviewCount,
					item.winCount,
					_yOrN(item.fileDir && item.fileSaveName),
					_yOrN(item.isActivity),
				];
				if (getters.hasAuthority) {
					row.splice(5, 0, item.userTel);
				}
				return row;
			});
			const title = `회원검색(${params.offset + 1}-${params.offset + rows.length})_${new Date().getTime()}`;
			const colNames = [
				'회원번호',
				'닉네임',
				'회원 등급',
				'블라인드 여부',
				'이메일',
				'휴대폰 번호',
				'가입일',
				'sns연동',
				'성별',
				'나이',
				'피부타입',
				...beautyProfileTypeList.map(item => item.type),
				'픽플',
                '휴대폰 인증',
				'인스타그램',
				'URL',
				'인스타그램 카테고리',
				'안드로이드',
				'IOS',
				'단말관련정보',
				'리뷰 수',
				'블라인드리뷰 수',
				'당첨 수',
				'이미지',
				'활동여부',
			];
			util.getCsv(
				[rows],
				[title],
				[
					getters.hasAuthority
						? colNames
						: colNames.filter(
								name => !['휴대폰 번호'].includes(name)
							),
				],
				`글로우픽_${title.replace(/ /g, '_')}`,
				config.url
			);
		} catch (err) {
			console.error(err);
			alert(
				'엑셀 파일을 다운로드하는데 실패했습니다. 개발팀에 문의하세요.'
			);
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
